<template>
    <div class="dynamic-group">
        <template v-for="(item, key) in list">
            <el-select 
                v-model="info[item.key]" 
                :placeholder="item.placeholder || ''" 
                :key="key" 
                :disabled="!resultList[item.key] || resultList[item.key].length <= 0" 
                @change="e => change(e, key)"
            >
                <el-option v-for="city in resultList[item.key]" :key="city.id" :value="city.id" :label="city.name" ></el-option>
            </el-select>
        </template>
    </div>
</template>
<script>
export default {
    name: 'DynamicSelect',
    props: {
        list: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        callback: Function
    },
    data () {
        let info = {}
        if (this.list && this.list.length > 0) {
            this.list.map(item => {
                info[item.key] = '' 
            })
        }
        return {
            info,
            resultList: []
        }
    },
    mounted () {
        this.change && this.change('', -1)
    },
    methods: {
        change (val, key) {
            const item = this.list[key + 1]
            if (!item) return null
            if (this.callback) {
                this.callback(val, item.key).then(data => {
                    this.list.map((v, index) => {
                        if (index === key + 1) {
                            this.$set(this.resultList, v.key, data)
                            this.$set(this.info, v.key, '')
                        } else if (index > key + 1) {
                            this.$set(this.resultList, v.key, [])
                            this.$set(this.info, v.key, '')
                        }
                    })
                })
            }
        },
        getEndData () {
            let data = ''
            for (let i = this.list.length - 1; i >= 0 ; i -- ) {
                const target = this.list[i]
                if (this.info[target.key] !== '') {
                    data = this.info[target.key]
                    break
                }
            }
            return data
        },
    }
}
</script>
<style scoped lang="less">
.dynamic-group{
    display: -webkit-box;
    .el-select{
        display: block;
        -webkit-box-flex: 1;
    }
}
</style>